<template>
    <section class="lg:min-h-[600px] lg:py-20 py-10 min-h-52" :style="{ background: sectionBackgroundColor }">
        <div class="mx-auto max-w-screen-2xl" >
      <div class="px-4 lg:px-8">
        <div class="relative px-10 mx-auto sm-max:px-6">
  
          <ClientOnly>
            <Swiper
                :class="'relative overflow-hidden'"
                :autoplay="{ delay: 4000, disableOnInteraction: true, pauseOnMouseEnter: true }"
                :modules="[SwiperNavigation,SwiperAutoplay]"
                :slidesPerView="1"
                :spaceBetween="50"
                :loop="true"
                :navigation = "{
                  nextEl: '.swiper-button-next-1',
                  prevEl: '.swiper-button-prev-1'
                }"
                :breakpoints="{
                  768: { slidesPerView: 2 },
                  1200: { slidesPerView: 3 },
                }">
              <SwiperSlide v-for="slide in slides" :key="slide.name">
                <div class="flex flex-col text-center">
                  <nuxt-img
                      class="w-full m-auto"
                      loading="lazy"
                      format="webp"
                      width="460"
                      height="259"
                      :alt="slide.imgAlt"
                      sizes="xs:263px sm:380px md:100vw lg:420px xl:460px"
                      :src="slide.imgSrc"
                  />
                  <div class="pt-8 text-3xl" :style="{ color: ratingColor }">{{ slide.rating }}</div>
                  <div
                      class="h-full pt-2 mb-4 textp"
                      :style="{ color: testimonialColor }"
                      v-html="slide.testimonial">
                  </div>
                  <h3 class="font-semibold h4" :style="{ color: nameColor }" v-html="slide.name"></h3>
                  <h4 class="leading-5 textp" :style="{ color: titleColor }">{{ slide.title }}</h4>
                </div>
              </SwiperSlide>
            </Swiper>
  
            <div class="absolute cursor-pointer swiper-button-prev-1 -translate-x-2/4 -translate-y-2/4 top-2/4 md:left-0 lg:-left-3 -left-0">
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 256 256" enable-background="new 0 0 256 256" xml:space="preserve">
                <g>
                  <g>
                    <path :fill="svgFillColor" d="M152.2,18.2l-87.3,85.6c-0.6,0.5-1.4,0.7-2,1.3c-11.3,11.1-11.5,29.3-0.4,40.6l90,91.8c11.1,11.3,29.2,11.5,40.6,0.4c5.7-5.6,8.6-13.1,8.6-20.5c0-7.2-2.7-14.5-8.2-20.1l-69.6-70.9l68.5-67.1c5.7-5.6,8.6-13.1,8.6-20.5c0-7.2-2.7-14.5-8.2-20.1C181.7,7.3,163.6,7.1,152.2,18.2z"/>
                  </g>
                </g>
              </svg>
            </div>
            <div class="absolute cursor-pointer swiper-button-next-1 -translate-x-2/4 -translate-y-2/4 top-2/4 md:-right-6 lg:-right-8 -right-6 sm:-right-6">
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 256 256" enable-background="new 0 0 256 256" xml:space="preserve">
                <g>
                  <g>
                    <path :fill="svgFillColor" d="M152.2,18.2l-87.3,85.6c-0.6,0.5-1.4,0.7-2,1.3c-11.3,11.1-11.5,29.3-0.4,40.6l90,91.8c11.1,11.3,29.2,11.5,40.6,0.4c5.7-5.6,8.6-13.1,8.6-20.5c0-7.2-2.7-14.5-8.2-20.1l-69.6-70.9l68.5-67.1c5.7-5.6,8.6-13.1,8.6-20.5c0-7.2-2.7-14.5-8.2-20.1C181.7,7.3,163.6,7.1,152.2,18.2z"/>
                  </g>
                </g>
              </svg>
            </div>
  
          </ClientOnly>
        </div>
      </div>
    </div>
    </section>
  </template>
  
  <script setup>
  const props = defineProps({
    slides: {
      type: Array,
      default: () => [
      {
        imgSrc: "/assets/images/aron-profile-img.jpg",
        imgAlt: "Shaun Hadsall",
        rating: "★★★★★",
        testimonial: "“Lifeboost Coffee is my favorite! It’s extremely low acid and easy on the stomach. It gets my 5 star recommendation.",
        name: "Dr Aaron Oxenrider",
        title: "Board Certified Chiropractic Physician and Regenerative Medicine Expert",
      },
      {
        imgSrc: "/assets/images/gary-profile-img.jpg",
        imgAlt: "Dr Gary Sanchez",
        rating: "★★★★★",
        testimonial: "“Best tasting low acid coffee ever! And it’s great on your teeth!”",
        name: "Dr Gary Sanchez",
        title: "Board Certified Dentist",
      },
      {
        imgSrc: "/assets/images/joseph-profile-img.jpg",
        imgAlt: "Dr Aaron Oxenrider",
        rating: "★★★★★",
        testimonial: "“Lifeboost Coffee is one of the healthiest, smoothest coffee's I've ever had. The ultra low acidity makes it perfect for those with stomach issues and digestive problems. Couple that with the rich, full bodied flavor and it's a treat I look forward to every day.”",
        name: "Joseph R. Feste, M.D., FACOG, AACS, AACG",
        title: "Natural Bio Health Hormones & Weight Loss.",
      },
      {
        imgSrc: "/assets/images/shaun-profile-img.jpg",
        imgAlt: "Dr Aaron Oxenrider",
        rating: "★★★★★",
        testimonial: "\"Lifeboost is by far the smoothest, most delicious coffee I've ever tasted. Whether I'm using intermittent fasting or just need a burst of energy and focus for my intense work load, Lifeboost delivers the cleanest, purest coffee energy you can find. I look forward to my daily cup (or two) each day to help boost my immune health and increase my productivity.\"",
        name: "Shaun Hadsall",
        title: "Owner of GetLeanAfter40",
      },
      {
        imgSrc: "/assets/images/john-profile-img.jpg",
        imgAlt: "Dr Aaron Oxenrider",
        rating: "★★★★★",
        testimonial: "\"Wow! This coffee is incredible! Super smooth and the lowest acid coffee I've ever drank. It doesn't hurt my stomach at all! Careful though, it goes down really fast! It's my perfect way to start out my morning with a cool smooth burst of energy. Thanks Dr Charles!\"",
        name: "John Rowley",
        title: "America's Lifestyle Strategist, Best Selling Author and Speaker",
      },
    ],
    },
    sectionBackgroundColor: {
      type: String,
      default: "white"
    },
    ratingColor: {
      type: String,
      default: "#f4b400" // Default yellow for rating
    },
    testimonialColor: {
      type: String,
      default: "black"
    },
    nameColor: {
      type: String,
      default: "black"
    },
    titleColor: {
      type: String,
      default: "black"
    },
    svgFillColor: {
      type: String,
      default: "#956449"
    }
  });
  
  defineBuilderComponent({
    friendlyName: "Testimonials With Options Colors",
    canHaveChildren: true,
    inputs: [
      {
        name: "slides",
        type: "list",
        subFields: [
          {
            name: "imgSrc",
            type: "file",
            allowedFileTypes: ["jpeg", "jpg", "png", "svg"],
            defaultValue: ""
          },
          {
            name: "imgAlt",
            type: "string",
            defaultValue: ""
          },
          {
            name: "rating",
            type: "string",
            defaultValue: ""
          },
          {
            name: "testimonial",
            type: "string",
            defaultValue: ""
          },
          {
            name: "name",
            type: "string",
            defaultValue: ""
          },
          {
            name: "title",
            type: "string",
            defaultValue: ""
          }
        ],
        defaultValue: [
                {
                    imgSrc: "/assets/images/aron-profile-img.jpg",
                    imgAlt: "Shaun Hadsall",
                    rating: "★★★★★",
                    testimonial: "“Lifeboost Coffee is my favorite! It’s extremely low acid and easy on the stomach. It gets my 5 star recommendation.",
                    name: "Dr Aaron Oxenrider",
                    title: "Board Certified Chiropractic Physician and Regenerative Medicine Expert"
                },
                {
                    imgSrc: "/assets/images/gary-profile-img.jpg",
                    imgAlt: "Dr Gary Sanchez",
                    rating: "★★★★★",
                    testimonial: "“Best tasting low acid coffee ever! And it’s great on your teeth!”",
                    name: "Dr Gary Sanchez",
                    title: "Board Certified Dentist"
                },
                {
                    imgSrc: "/assets/images/joseph-profile-img.jpg",
                    imgAlt: "Dr Aaron Oxenrider",
                    rating: "★★★★★",
                    testimonial: "“Lifeboost Coffee is one of the healthiest, smoothest coffee's I've ever had. The ultra low acidity makes it perfect for those with stomach issues and digestive problems. Couple that with the rich, full bodied flavor and it's a treat I look forward to every day.”",
                    name: "Joseph R. Feste, M.D., FACOG, AACS, AACG",
                    title: "Natural Bio Health Hormones & Weight Loss."
                },
                {
                    imgSrc: "/assets/images/shaun-profile-img.jpg",
                    imgAlt: "Dr Aaron Oxenrider",
                    rating: "★★★★★",
                    testimonial: "\"Lifeboost is by far the smoothest, most delicious coffee I've ever tasted. Whether I'm using intermittent fasting or just need a burst of energy and focus for my intense work load, Lifeboost delivers the cleanest, purest coffee energy you can find. I look forward to my daily cup (or two) each day to help boost my immune health and increase my productivity.\"",
                    name: "Shaun Hadsall",
                    title: "Owner of GetLeanAfter40"
                },
                {
                    imgSrc: "/assets/images/john-profile-img.jpg",
                    imgAlt: "Dr Aaron Oxenrider",
                    rating: "★★★★★",
                    testimonial: "\"Wow! This coffee is incredible! Super smooth and the lowest acid coffee I've ever drank. It doesn't hurt my stomach at all! Careful though, it goes down really fast! It's my perfect way to start out my morning with a cool smooth burst of energy. Thanks Dr Charles!\"",
                    name: "John Rowley",
                    title: "America's Lifestyle Strategist, Best Selling Author and Speaker"
                }
            ]
      },
      {
        name: "sectionBackgroundColor",
        type: "color",
        friendlyName: "Section Background Color",
        defaultValue: "white"
      },
      {
        name: "ratingColor",
        type: "color",
        friendlyName: "Rating Color",
        defaultValue: "#f4b400"
      },
      {
        name: "testimonialColor",
        type: "color",
        friendlyName: "Testimonial Text Color",
        defaultValue: "black"
      },
      {
        name: "nameColor",
        type: "color",
        friendlyName: "Name Text Color",
        defaultValue: "black"
      },
      {
        name: "titleColor",
        type: "color",
        friendlyName: "Title Text Color",
        defaultValue: "black"
      },
      {
        name: "svgFillColor",
        type: "color",
        friendlyName: "Arrow Icon Fill Color",
        defaultValue: "#956449"
      }
    ]
  });
  </script>
  
  <style>
  .swiper-wrapper {
    width: 100%;
    height: 100%;
  }
  
  .swiper-button-next,
  .swiper-button-prev {
    @apply !text-productTitle sm-max:pl-2 pt-8;
  }
  
  .swiper-button-next-1,
  .swiper-button-prev-1 {
    width: 24px;
    height: 30px;
    display: inline-block;
  }
  
  .swiper-button-next-1 svg {
    transform: rotate(180deg);
  }
  </style>
  